import React from 'react';
import cx from 'classnames';
import { LinkV2 } from '../LinkV2';
import dateHelper from '../../util/dateHelper';

import styles from './MinimalFooter.module.less';

type MinimalFooterProps = {
  position?: 'relative' | 'absolute' | 'fixed';
  className?: string;
};

const MinimalFooter: React.FC<MinimalFooterProps> = ({ position = 'relative', className }) => {
  const year = dateHelper.getFullYear();
  return (
    <footer className={cx(styles.footer, styles[position], className)}>
      &copy; {year} Zola, Inc.
      <span className={styles.notMobile}> All rights reserved.</span>
      <span className={styles.links}>
        <LinkV2
          href="/privacy"
          variant="primary"
          target="_blank"
          rel="noopener noreferrer"
          noUnderline
        >
          Privacy Policy
        </LinkV2>{' '}
        /{' '}
        <LinkV2
          href="/terms"
          variant="primary"
          target="_blank"
          rel="noopener noreferrer"
          noUnderline
        >
          Terms of Use
        </LinkV2>
        <span className={styles.notMobile}> / </span>
        <br className={styles.showMobile} />
        <LinkV2
          href="/webaccessibility"
          variant="primary"
          target="_blank"
          rel="noopener noreferrer"
          noUnderline
        >
          Web Accessibility
        </LinkV2>{' '}
        /{' '}
        <LinkV2 href="/privacy-center" target="_blank" rel="noopener noreferrer" noUnderline>
          Do Not Sell or Share My Personal Information
        </LinkV2>
      </span>
    </footer>
  );
};

export default MinimalFooter;
